import React, { useEffect, useState } from "react";
import { IonItem, IonDatetime } from "@ionic/react";

import "./TimePickerComponent.scss";
import { utilService } from "../../../services/utilService";
import { useToast } from "@agney/ir-toast";
import { useTranslation } from "react-i18next";

/**
 * Time-picker component
 * Component will show a popup to select hour and minute.
 * Component will return the time in the format 24 hours format.
 */

interface TimePickerProps {
  getSelectedTime: (value: string) => void;
  timeValue?: string;
  favCardData?: any;
  isFromEMS?: any;
  teamStartTime?: any;
  teamStartDate?: any;
  teamEndDate?: any;
  teamExpiryTime?: any;
  timePickerLabel?: string;
  teamLinkUser?: boolean;
  selectionUpdate?: any;
}

interface resultFormat {
  ampm: { value: string };
  hour: { value: number };
  minute: { value: number };
}

const TimePicker: React.FC<TimePickerProps> = (props) => {
  const { t } = useTranslation("schedule");
  let currTime = utilService.getCurrentTime();
  const [selectedTime, setSelectedTime] = useState<string>(currTime);
  const [teamStartTimeData, setTeamStartTime]: any = useState();
  const [teamExpiryTimeData, setTeamExpiryTime]: any = useState();

  const Toast = useToast();

  const getCurrentTime = () => {
    currTime = utilService.getCurrentTime();
    setSelectedTime(currTime);
  };

  useEffect(() => {
    getCurrentTime();
  }, []);

  useEffect(() => {
    if (props.teamLinkUser) {
      setTeamStartTime(props.teamStartTime);
      setTeamExpiryTime(props.teamExpiryTime);
    }
  }, [props.teamLinkUser]);

  useEffect(() => {
    setTimeValue();
    // setTimeForFavCard();
  }, [props.timeValue]);

  const setTimeValue = () => {
    if (props.timeValue) {
      setSelectedTime(props.timeValue);
    } else {
      props.getSelectedTime(currTime);
    }
  };

  // const setTimeForFavCard = () => {
  //   if (!_.isEmpty(props.favCardData)) {
  //     getCurrentTime();
  //     props.getSelectedTime(currTime);
  //   }
  // };

  const handleChange = (res: any) => {
    let validateTime = validateSelectedTime(res);
    // let formattedTime = dayjs(res).format("hh:mm A");
    if (props.teamLinkUser) {
      if (validateTime) {
        props.getSelectedTime(res);
        setSelectedTime(res);
      } else {
        updateTimeInput();
      }
    } else {
      props.getSelectedTime(res);
      setSelectedTime(res);
    }
  };

  const updateTimeInput = () => {
    switch (props.timePickerLabel) {
      case "start_time":
        setSelectedTime(teamStartTimeData);
        props.getSelectedTime(teamStartTimeData);
        break;
      case "expiry_time":
        setSelectedTime(teamExpiryTimeData);
        props.getSelectedTime(teamExpiryTimeData);
    }
    setSelectedTime(teamStartTimeData);
    props.getSelectedTime(teamStartTimeData);
  };

  const validateSelectedTime = (selectedTime: any) => {
    switch (props.timePickerLabel) {
      case "start_time":
        return true;
      case "expiry_time":
        return true;
        break;
    }
  };

  return (
    <IonItem
      lines="none"
      // className={props.isFromEMS ? "ems-input-padding" : ""}
    >
      <IonDatetime
        presentation="time"
        color="aqua"
        value={selectedTime}
        cancelText={t("cancel")}
        doneText="OK"
        onIonChange={(e) => {
          e.stopImmediatePropagation();
          handleChange(e.detail.value!);
        }}
        // display-format=""
        // picker-format="hh:mm A"
        locale="en-US"
      ></IonDatetime>
    </IonItem>
  );
};

export default TimePicker;
